import { useOrganizationUsageQuery } from "./useOrganizationUsageQuery";

import { ENDPOINTS } from "@/api/application-api";
import {
  GetOrganizationUsageChartDataParams,
  OrganizationUsageChartData,
} from "@/types/organization-usage";

export const useOrganizationUsageChartData = (params: GetOrganizationUsageChartDataParams) =>
  useOrganizationUsageQuery<OrganizationUsageChartData>({
    ...params,
    queryKey: "organization_usage_workspaces_usage",
    endpoint: ENDPOINTS.organization_usage_workspaces_usage,
  });
